// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportedFuncCache32;
var wasmImportedFuncCache33;
var wasmImportedFuncCache34;
var wasmImportedFuncCache35;
var wasmImportedFuncCache36;
var wasmImportedFuncCache37;
var wasmImportObjects = {
	27258: function() {
		return {
			"./cardano_multiplatform_lib_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache0["ug$"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache1["h4u"](p0i32,p1i32);
				},
				"__wbindgen_string_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache2["qtq"](p0i32,p1i32);
				},
				"__wbindgen_json_parse": function(p0i32,p1i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache3["t$0"](p0i32,p1i32);
				},
				"__wbg_crypto_8fd02d72c4ba6c5c": function(p0i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache4["NLb"](p0i32);
				},
				"__wbindgen_is_object": function(p0i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache5["WlW"](p0i32);
				},
				"__wbg_process_bd02d71a65cf734c": function(p0i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache6["e58"](p0i32);
				},
				"__wbg_versions_1d70d407cb23129d": function(p0i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache7["DVm"](p0i32);
				},
				"__wbg_node_0091cdf1ffa73e4d": function(p0i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache8["tKO"](p0i32);
				},
				"__wbindgen_is_string": function(p0i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache9["eYF"](p0i32);
				},
				"__wbg_require_b06abd91965488c8": function() {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache10["qtV"]();
				},
				"__wbg_msCrypto_7e1e6014bddd75de": function(p0i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache11["IJU"](p0i32);
				},
				"__wbg_getRandomValues_f308e7233e5601b7": function(p0i32,p1i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache12["Anh"](p0i32,p1i32);
				},
				"__wbg_randomFillSync_f20541303a990429": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache13["bXi"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_is_function": function(p0i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache14["o$X"](p0i32);
				},
				"__wbg_newnoargs_971e9a5abe185139": function(p0i32,p1i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache15["_f4"](p0i32,p1i32);
				},
				"__wbg_call_33d7bcddbbfa394a": function(p0i32,p1i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache16["Jmo"](p0i32,p1i32);
				},
				"__wbg_self_fd00a1ef86d1b2ed": function() {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache17["Ath"]();
				},
				"__wbg_window_6f6e346d8bbd61d7": function() {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache18["Hcj"]();
				},
				"__wbg_globalThis_3348936ac49df00a": function() {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache19["lHB"]();
				},
				"__wbg_global_67175caf56f55ca9": function() {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache20["qNE"]();
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache21["XP4"](p0i32);
				},
				"__wbg_call_65af9f665ab6ade5": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache22["PZ2"](p0i32,p1i32,p2i32);
				},
				"__wbg_buffer_34f5ec9f8a838ba0": function(p0i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache23["eAr"](p0i32);
				},
				"__wbg_new_cda198d9dbc6d7ea": function(p0i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache24["G0U"](p0i32);
				},
				"__wbg_set_1a930cfcda1a8067": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache25["FS1"](p0i32,p1i32,p2i32);
				},
				"__wbg_length_51f19f73d6d9eff3": function(p0i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache26["YwE"](p0i32);
				},
				"__wbg_newwithlength_66e5530e7079ea1b": function(p0i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache27["_JX"](p0i32);
				},
				"__wbg_subarray_270ff8dd5582c1ac": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache28["Kms"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache29["m_1"](p0i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache30["fYP"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache31["Or8"](p0i32,p1i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache32 === undefined) wasmImportedFuncCache32 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache32["oHO"]();
				}
			}
		};
	},
	13885: function() {
		return {
			"./cardano_message_signing_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache33 === undefined) wasmImportedFuncCache33 = __webpack_require__.c[78263].exports;
					return wasmImportedFuncCache33["ug"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache34 === undefined) wasmImportedFuncCache34 = __webpack_require__.c[78263].exports;
					return wasmImportedFuncCache34["h4"](p0i32,p1i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache35 === undefined) wasmImportedFuncCache35 = __webpack_require__.c[78263].exports;
					return wasmImportedFuncCache35["fY"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache36 === undefined) wasmImportedFuncCache36 = __webpack_require__.c[78263].exports;
					return wasmImportedFuncCache36["Or"](p0i32,p1i32);
				},
				"__wbindgen_rethrow": function(p0i32) {
					if(wasmImportedFuncCache37 === undefined) wasmImportedFuncCache37 = __webpack_require__.c[78263].exports;
					return wasmImportedFuncCache37["nD"](p0i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"13866": [
		27258
	],
	"85573": [
		13885
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"13866":{"27258":"bb0feacf38b4ca8a115c"},"85573":{"13885":"4dcc6a4a8627470ec115"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};